import React from 'react';
import Head from 'next/head';
import { escapeForScript } from './utils';

interface SchemaInterface {
  data: Record<string, unknown> | unknown[] | string;
  name: string;
}

export const Schema: React.FC<SchemaInterface> = ({ data, name }) => {
  const schemaName = `${name}-schema`;
  const serialized = typeof data === 'string' ? data : JSON.stringify(data);
  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{ __html: escapeForScript(serialized) }}
        id={schemaName}
        key={schemaName}
        type="application/ld+json"
      />
    </Head>
  );
};
